module.exports = __webpack_public_path__ + "static/ripio-53c57d06e213ccd7b859abe57098c9db.png";